"use client";

import React from "react";
import { usePath } from "@/hooks/usePath";
import { faqLinks } from "@/utils/appUrls";
import FaqLink from "@/src/components/Common/FaqLink";
import { useSidebarTutorial } from "@/context/SidebarTutorialContext";

const FAQ_ROUTES: Array<[string, string]> = [
  ["/dashboard/my-profile", faqLinks.myProfile],
  ["/dashboard/my-events", faqLinks.myEvents],
  ["/dashboard/my-programs", faqLinks.myPrograms],
  ["/dashboard/my-reporting", faqLinks.myReporting],
  ["/materials-library", faqLinks.materialsLibrary],
  ["/events", faqLinks.events],
  ["/training", faqLinks.training],
  ["/cookie-consent", faqLinks.cookies],
  ["/dashboard", faqLinks.dashboard],
];

const PageFaqLink: React.FC = () => {
  const pathname = usePath();
  const { pageFaqLinkRef } = useSidebarTutorial();

  const match = FAQ_ROUTES.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`));

  if (!match) return null;

  return <FaqLink ref={pageFaqLinkRef} href={match[1]} />;
};

export default PageFaqLink;
